export const initialState = null;

export const reducer = (state, action) => {
    if(action.type === "USER") {
        return action.payload;
    }
    if(action.type === "UPDATEPROFILEPIC") {
        return {
            ...state,
            profilepic: action.payload
        }
    }
    return state;
}